import { ApplicationEnvironment } from '../../entities/catalog/application.environment';
import { EnvironmentConfiguration } from './environment.configuration';

export const environmentHotfix = {
  locale: 'en-AU',
  production: true,
  api: '/api',
  domain: 'workbuddy.hot',
  auth: {
    local: {
      callbackUrl: 'http://{0}:4000/callback',
    }
  },
  jms: {
    loginHref: 'https://id.workbuddy.hot',
    logoutHref: 'https://id.workbuddy.hot/logout',
    captcha: '6LfQ01oUAAAAAFfG2a8ZR509QugrxclKGsINjcKN',
    captchaSecret: '6LfQ01oUAAAAAFfjjGsSDeMfCc9ZPTAMswBcBh8y',
  },
  sentry: {
    dsn: '',
    name: '',
    release: '',
    environment: ''
  },
  environment: ApplicationEnvironment.Hotfix
} as EnvironmentConfiguration;